import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Portfolio from '../components/Portfolio/Portfolio';
import News from '../components/News/News';
import Contact from '../components/Contact/Contact';
import CVSection from '../components/CV/CVSection';

// HomePage component combining multiple sections
const HomePage = () => (
  <>
    <Helmet>
      <title>Gerald Suleh | Senior Engineer - SOC & Cybersecurity Lead</title>
      <meta name="description" content="Official portfolio of Gerald Suleh, Senior Engineer - Security Operations Center at USIU-Africa. Cybersecurity & Digital Resilience Lead specializing in SOC, AI-driven automation, VAPT, and blockchain security." />
      <meta name="keywords" content="Gerald Suleh, Senior SOC Engineer, Cybersecurity, AI Automation, VAPT, Blockchain, USIU-Africa, Nairobi" />
    </Helmet>
    <Hero />
    <About />
    <Portfolio />
    <News />
    <Contact />
  </>
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Homepage route showing all sections */}
        <Route index element={<HomePage />} />
        
        {/* Individual section routes */}
        <Route path="about" element={
          <>
            <Helmet>
              <title>About | Gerald Suleh</title>
              <meta name="description" content="Learn about Gerald Suleh's background, skills, and professional journey as Secretary Na Malkia and Backend Developer." />
            </Helmet>
            <About />
          </>
        } />
        <Route path="portfolio" element={
          <>
            <Helmet>
              <title>Portfolio | Gerald Suleh</title>
              <meta name="description" content="Explore Gerald Suleh's technical projects and community initiatives in cybersecurity, blockchain, and social impact." />
            </Helmet>
            <Portfolio />
          </>
        } />
        <Route path="news" element={
          <>
            <Helmet>
              <title>News | Gerald Suleh</title>
              <meta name="description" content="Latest updates, publications, and achievements from Gerald Suleh's professional work." />
            </Helmet>
            <News />
          </>
        } />
        <Route path="contact" element={
          <>
            <Helmet>
              <title>Contact | Gerald Suleh</title>
              <meta name="description" content="Get in touch with Gerald Suleh for cybersecurity consulting, backend development projects, or community initiatives." />
            </Helmet>
            <Contact />
          </>
        } />
        <Route path="cv" element={
          <>
            <Helmet>
              <title>CV | Gerald Suleh</title>
              <meta name="description" content="Gerald Suleh's professional CV, showcasing experience, education, certifications, and skills in technology and community leadership." />
            </Helmet>
            <CVSection />
          </>
        } />
        
        {/* 404 route - could be customized */}
        <Route path="*" element={
          <div className="flex items-center justify-center min-h-screen bg-white dark:bg-secondary-900">
            <div className="text-center">
              <h2 className="text-4xl font-bold text-secondary-900 dark:text-white mb-4">404</h2>
              <h3 className="text-2xl font-medium text-secondary-800 dark:text-secondary-200 mb-6">
                Page Not Found
              </h3>
              <p className="text-secondary-600 dark:text-secondary-400 mb-8 max-w-md">
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
              </p>
              <a 
                href="/" 
                className="bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-300"
              >
                Return Home
              </a>
            </div>
          </div>
        } />
      </Route>
    </Routes>
  );
};

export default AppRoutes;

